import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ClientsPage from "./pages/ClientsPage";
import ClientDetailPage from "./pages/ClientDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/sonner";
import { ClientsProvider } from "./contexts/ClientsContext";
import { ThemeProvider } from "./contexts/ThemeContext";

function App() {
  return (
    <div className="App grain font-body">
      <BrowserRouter>
        <ThemeProvider>
          <ClientsProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/clients" element={<ClientsPage />} />
                <Route path="/clients/:slug" element={<ClientDetailPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </Layout>
            <Toaster position="bottom-right" />
          </ClientsProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
